import React from "react";
import moment from "moment";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import CheckBox from "@material-ui/icons/CheckBox";
import withStyles from "@material-ui/styles/withStyles";
import { useCallback, useState, useEffect } from "react";
import CheckBoxOutlineBlank from "@material-ui/icons/CheckBoxOutlineBlank";

import { formatDate } from "utils/format.util";
import { EMPTY_LIST, Format } from "app/app.constants";

const DWIProjectsMultiSelectFieldList = ({
  label,
  input,
  classes,
  disabled,
  projects = EMPTY_LIST,
  employeeProjects = EMPTY_LIST,
  ...rest
}) => {
  const { onChange } = input;

  const [selectedProjects, setSelectedProjects] = useState(
    employeeProjects.toSet(),
  );

  useEffect(() => {
    onChange(selectedProjects);
  }, [selectedProjects, onChange]);

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item className={classes.title}>
          {"Assign Projects"}
        </Grid>

        {projects.size === 0 && (
          <Grid item container>
            {"N/A"}
          </Grid>
        )}
        {projects &&
          projects.map(project => {
            const isProjectMember = selectedProjects.find(
              x =>
                x.get("projectId")?.toString() ===
                project.get("projectId")?.toString(),
            );
            return (
              <Grid
                item
                container
                key={project.get("projectId")}
                className={classes.row}
              >
                <Grid xs={1} item>
                  {isProjectMember ? (
                    <CheckBox
                      onClick={() => {
                        return setSelectedProjects(
                          selectedProjects.filter(
                            x =>
                              x.get("projectId")?.toString() !==
                              project.get("projectId")?.toString(),
                          ),
                        );
                      }}
                    />
                  ) : (
                    <CheckBoxOutlineBlank
                      onClick={() => {
                        return setSelectedProjects([
                          ...selectedProjects,
                          project,
                        ]);
                      }}
                    />
                  )}
                </Grid>
                <Grid xs={4} item>
                  {project.get("displayName")}
                </Grid>
                <Grid item xs={2} className={classes.m3num}>
                  {project.get("m3ProjectNumber")}
                </Grid>
                <Grid item xs={3}>
                  <Grid item>
                    {project.get("startTime")
                      ? formatDate(
                          moment(project.get("startTime")),
                          Format.date,
                        )
                      : ""}{" "}
                    -{" "}
                    {project.get("endTime")
                      ? formatDate(moment(project.get("endTime")), Format.date)
                      : ""}
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};

const styles = theme => ({
  chip: {
    height: 27,
    marginLeft: 0,
    margin: theme.spacing(0.5),
  },
  m3num: {
    marginRight: "15px",
  },
});

export default compose(withStyles(styles))(DWIProjectsMultiSelectFieldList);
